module.exports = __webpack_public_path__ + "img/jp-cover.fd150f9b.png";